import React from 'react';
import {
	IonContent,
	IonPage,
	IonRefresher,
	IonRefresherContent,
} from '@ionic/react';
import { RouteComponentProps } from 'react-router';
import { Empty, Filter, Header, Item, TabsOffset } from 'components';
import { axius, func, types } from 'utils';
import { _store, _update } from '_Store';
import ItemBottomModal from '../components/ItemBottmModal';

let refresher: any = null;
interface Params {
	id: string;
}
interface Props extends RouteComponentProps, types.StateProps {}
const Category: React.FC<Props> = (props) => {
	const {
		__data: { categories, activeStore, location },
	} = _store.useState();

	const [step, setStep] = React.useState(0);
	const [data, setData] = React.useState([]);
	const [chunks, setChunks] = React.useState([]);
	const [loading, setLoading] = React.useState(true);

	const path = props.history.location.pathname.split('/')[2]?.split('.') || {};
	const params: Params = { id: path[1] };
	const [isItemModalOpen, setOpenedItemModal] = React.useState(false);
	const [selectProduct, setSelectProduct] = React.useState<types.Item>();
	React.useEffect(() => {
		getData();
		// window['$'](`#carousel-category-filterss`).owlCarousel(owlCarouselOptions);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [params.id]);

	const getNext = () => {
		setStep(step + 1);
		setData(data.concat(chunks[step + 1]));
	};

	const getData = () => {
		setLoading(true);
		window.scroll(0, 0);
		axius
			.post('search', {
				city: location.address.city,
				stores: [activeStore.code],
				resultTypes: ['items'],
				deliveryOptions: [location.option],
				categories: [
					categories.find((ctg: types.Category) => ctg.id === params.id)?.id,
				],
			})
			.then((res) => {
				if (res.status === 201) {
					var c = func.chunk(
						res.items
							.map((item: types.Item) => {
								return {
									...item,
									distance: +func.distanceMatrix(
										{
											lat: location?.address?.x,
											lng: location?.address?.y,
										},
										{
											lat: activeStore.address.x,
											lng: activeStore.address.y,
										},
										true
									),
								};
							})
							.sort((a: types.Item, b: types.Item) =>
								a.distance > b.distance ? 1 : -1
							)
							.filter(
								(prod: types.Item) =>
									prod.status === types.ItemStatuses.PUBLISHED
							),
						12
					);
					setChunks(c || [[]]);
					setData(c[0] || []);
				}
				setLoading(false);
				refresher && refresher.detail.complete();
			});
	};

	const ctg = (categories.find((ctg) => ctg.id === params.id) ||
		{}) as types.Category;

	return (
		<IonPage id="Category">
			<Header {...props} showSearch={true} showSegments={false} />
			<IonContent fullscreen={false}>
				<IonRefresher
					slot="fixed"
					onIonRefresh={(e) => {
						refresher = e;
						getData();
					}}
				>
					<IonRefresherContent></IonRefresherContent>
				</IonRefresher>
				<Filter {...props} />
				<div className="divider" />
				{!loading && chunks.flat().length === 0 && (
					<Empty
						style={{}}
						text={
							<div>
								{chunks.flat().length
									? func.numberFormat(chunks.flat().length)
									: 'No'}{' '}
								item{chunks.flat().length > 1 ? 's' : ''} found&nbsp;
								{ctg.id && (
									<span>
										in <span className="primary fw-600">{ctg.name}</span>
									</span>
								)}
							</div>
						}
					/>
				)}
				<div className="p-3">
					{loading &&
						[0, 1, 2, 3, 4].map((i) => (
							<div
								key={i}
								className="skeleton mb-2"
								style={{ borderRadius: 7, height: 160 }}
							/>
						))}

					{!loading &&
						data.length > 0 &&
						data.map(
							(item: types.Item) =>
								item.status === types.ItemStatuses.PUBLISHED && (
									<div key={item.id} className="mb-4s">
										<Item
											{...props}
											item={item}
											layout="list"
											handleSelectedItem={(item) => {
												setSelectProduct(item);
												setOpenedItemModal(true);
												_update.data('is_bottom_modal', { is_open: true });
											}}
										/>
									</div>
								)
						)}

					{chunks.flat().length > data.length && (
						<div
							className="text-center pointer small"
							onClick={() => getNext()}
						>
							Load more
						</div>
					)}
				</div>
				{selectProduct && (
					<ItemBottomModal
						isItemModalOpen={isItemModalOpen}
						setOpenedItemModal={setOpenedItemModal}
						selectedProduct={selectProduct}
					/>
				)}{' '}
				<TabsOffset />
			</IonContent>
		</IonPage>
	);
};

export default Category;
